import angular from 'angular';
import regulatorFormComponent from './regulator-add-form.component';

export default angular.module('components.app.dashboard.regulator-add-form', [])
  .component('regulatorAddForm', regulatorFormComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/admin/regulator/regulator-add-form/regulator-add-form.module.js